import { render, staticRenderFns } from "./CreateGradeForm.vue?vue&type=template&id=1d4b9b5c"
import script from "./CreateGradeForm.vue?vue&type=script&lang=js"
export * from "./CreateGradeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports